var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"button-next",attrs:{"to":(_vm.link)}},[_c('img',{attrs:{"src":require("@/assets/images/button-next.png"),"alt":"Next","title":"Next"}})])}
var staticRenderFns = []

export { render, staticRenderFns }